/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { itemTypeSchema } from "./itemTypeSchema.ts";

export const mobileOrderItemTypeEnumSchema = itemTypeSchema;
